// extracted by mini-css-extract-plugin
export default {"PostcodeSelect":"ONS8kD87cd"};